// Copyright © Veeam Software Group GmbH

import en from './roots/en.res.root';

import type { Languages } from './Types';

const languages: Languages<typeof en> = {
    en,
};

// eslint-disable-next-line import/no-default-export
export default languages;
